import { Box, IconButton, useTheme, Typography, Stack } from "@mui/material";
import { useContext } from "react";
import { Link } from 'react-router-dom'
import { ColorModeContext } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {Context} from "../../index";
import { tokens } from "../../theme";

const Topbar = ({toggled, setToggled, isCollapsed, setIsCollapsed, broken, setBroken}) => {
    const {store} = useContext(Context);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);

    const user = store.user

    return (
        <Box display="flex" justifyContent="space-between" height={'58px'}>
            
            <Stack
                direction='row'
                spacing={2}
                alignItems={"center"}
                justifyContent="space-between"
            >
                <IconButton onClick={() => { 
                    if (broken) {
                        setToggled(!toggled)
                        setIsCollapsed(false)
                    }
                    else {
                        setIsCollapsed(!isCollapsed)
                    }
                    }}>
                    <MenuOutlinedIcon />
                </IconButton>

                {broken || isCollapsed ? 
                    (
                        <Typography
                            variant="h4"
                            color={colors.grey[100]}
                            fontWeight="bold"
                            sx={{ m: "10px 0 0 0" }}
                        >
                            {store.user.name}
                        </Typography>
                    )
                    : undefined
                }
            </Stack>

            {/* SEARCH BAR */}
            {/* <Box sx={{ width: "320px" }}>
                <LiveSearch />
            </Box> */}
            {/* ICONS */}
            <Box display="flex">
                <IconButton onClick={colorMode.toggleColorMode}>
                    {theme.palette.mode === "dark" ? (
                        <DarkModeOutlinedIcon />
                    ) : (
                        <LightModeOutlinedIcon />
                    )}
                </IconButton>
                <IconButton component={Link} to="/notification">
                    <NotificationsOutlinedIcon />
                </IconButton>
                <IconButton component={Link} to="/settings">
                    <SettingsOutlinedIcon />
                </IconButton>
                <IconButton component={Link} to="/profile">
                    <PersonOutlinedIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default Topbar;